export default __webpack_public_path__ + "static/media/Cheerleader.889d2932.png";